import React, { useState } from 'react';
import clsx from 'clsx';
import { ListItem, ListItemIcon, ListItemText, Icon } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { useAuth } from 'hook/auth';
import { icons } from 'asset';
import useStyles from './styles';
import { useConfig } from 'hook/config';
import logo from 'asset/image/logo.png';
import { Divider, Typography } from '@material-ui/core';
import HospitalList from './components/hospitalList';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';

export const MenuSidebar = ({ handleCleanCheckbox }) => {
  const routesWithPermissions = [
    {
      path: '/plantoes',
      label: 'Visão Geral',
      permission: 'admin/overview',
      icon: 'analytics',
    },
    {
      path: '/tempo-real',
      label: 'Tempo Real',
      permission: 'schedule/real-time',
      icon: 'access_time',
    },
    {
      path: '/dashboard',
      label: 'Dashboard',
      permission: 'dashboard',
      icon: 'grid_view',
    },
    {
      path: '/escala-do-dia',
      label: 'Escala do dia',
      permission: 'scale/day',
      icon: icons.howToReg,
      isImage: true,
    },
    {
      path: '/relatorio-de-trocas',
      label: 'Trocas',
      permission: 'schedule/exchanges',
      icon: icons.repeat,
      isImage: true,
    },
    {
      path: '/relatorios',
      label: 'Relatórios',
      permission: 'report/r',
      icon: icons.timeline,
      isImage: true,
    },
  ];

  const history = useHistory();
  const { config, setConfig } = useConfig(false);
  const [data, setData] = useState(moment().format('lll'));
  const classes = useStyles();
  const { logout, userLogged, getUserPermissions, userPermissions } = useAuth();
  const logoutFunction = () => {
    logout();
    setConfig({ ...config, hospitalData: [] });
    history.push('/login');
  };

  React.useEffect(() => {
    getUserPermissions();
    return history.listen(() => {
      setData(moment().format('lll'));
    });
  }, [history]);

  const changeListHospital = (id, type) => () => {
    const scaleLocal = localStorage && localStorage.getItem('selectedScale');
    const scaleJsonInLocal =
      localStorage.getItem('selectedScale') && JSON.parse(scaleLocal);
    const scaleInArray = scaleJsonInLocal ? scaleJsonInLocal : [];

    const selectedLocalUnit = localStorage.getItem('selectedLocalUnit');
    const selectedLocalUnitJsonInLocal =
      selectedLocalUnit && JSON.parse(selectedLocalUnit);

    const removedItemList = config.hospitalData.filter(
      (item) => item.id !== id
    );

    const removedScaleInList = removedItemList
      .map((item) => scaleInArray.filter((scale) => scale.unit === item.id))
      .flat();

    if (selectedLocalUnitJsonInLocal?.id === id) {
      removedItemList.length &&
        localStorage.setItem(
          'selectedLocalUnit',
          JSON.stringify(removedItemList[0])
        );
    }

    localStorage.setItem(
      'selectedScale',
      JSON.stringify([...removedScaleInList])
    );
    localStorage.setItem(
      'plantãoExtra@hospital',
      JSON.stringify([...removedItemList])
    );
    setConfig({
      ...config,
      hospitalData: [...removedItemList],
      hospitalId: [...removedItemList],
    });
    handleCleanCheckbox && handleCleanCheckbox(id);
    type === 'change' && !handleCleanCheckbox && history.push('/');
  };

  const userHasPermission = (permission) => {
    const isAdmin = userLogged?.group?.id === 1;
    const permissionsObject = userPermissions?.dataPermissions;

    if (isAdmin) return true;

    if (permissionsObject && typeof permissionsObject === 'object') {
      return Object.keys(permissionsObject).some(
        (key) => key === permission && permissionsObject[key] === 1
      );
    }

    return false;
  };
  const renderNavLink = (path, label, icon, isImage = false) => {
    if (!userHasPermissionByPath(path)) return null;

    return (
      <NavLink
        key={path}
        to={path}
        className={classes.navLink}
        activeClassName={classes.navLinkActive}
        style={{ textDecoration: 'none' }}
      >
        <ListItem
          button
          className={clsx('h-12', !config.open && classes.listItemCollapsed)}
        >
          <Tooltip title={label} placement="right">
            <ListItemIcon>
              {isImage ? (
                <img
                  src={icon}
                  alt=""
                  className="sidebar-nav-img"
                  style={{ maxWidth: 24, maxHeight: 24 }}
                />
              ) : (
                <Icon
                  className={classes.icons}
                  style={{ color: 'inherit', fontSize: 22 }}
                >
                  {icon}
                </Icon>
              )}
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            primary={label}
            className={clsx(!config.open && classes.listItemTextHidden)}
          />
        </ListItem>
      </NavLink>
    );
  };

  const userHasPermissionByPath = (path) => {
    const route = routesWithPermissions.find((r) => r.path === path);
    if (!route) return true;
    return userHasPermission(route.permission);
  };

  return (
    <div className="flex flex-col justify-between h-[100%]">
      <div>
        {config.hospitalData?.length === 0 && (
          <>
            {renderNavLink('/inicio', 'Início', 'grid_view')}
            {userHasPermission('admin/overview') &&
              renderNavLink('/plantoes', 'Visão Geral', 'analytics')}
          </>
        )}

        {/* DEPOIS de selecionar hospital */}
        {config.hospitalData?.length > 0 && (
          <>
            {userHasPermission('schedule/real-time') &&
              renderNavLink('/tempo-real', 'Tempo Real', 'access_time')}

            {userHasPermission('dashboard') &&
              renderNavLink('/dashboard', 'Dashboard', 'grid_view')}

            {config.hospitalData.map((item) => (
              <HospitalList
                key={item.id}
                length={config.hospitalData.length}
                item={item}
                changeHospital={changeListHospital(item.id, 'change')}
                removeHospital={changeListHospital(item.id)}
              />
            ))}

            {userHasPermission('scale/day') &&
              renderNavLink(
                '/escala-do-dia',
                'Escala do dia',
                icons.howToReg,
                true
              )}

            <NavLink
              to="/agenda"
              className={classes.navLink}
              activeClassName={classes.navLinkActive}
              style={{ textDecoration: 'none' }}
            >
              <ListItem
                button
                className={clsx(
                  'h-12',
                  !config.open && classes.listItemCollapsed
                )}
                id="btnAgenda"
              >
                <Tooltip title="Agenda" placement="right">
                  <ListItemIcon>
                    <img
                      src={icons.today}
                      alt=""
                      className="sidebar-nav-img"
                      style={{ maxWidth: 24, maxHeight: 24 }}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText
                  primary="Agenda"
                  className={clsx(!config.open && classes.listItemTextHidden)}
                />
              </ListItem>
            </NavLink>

            {userHasPermission('schedule/exchanges') &&
              renderNavLink(
                '/relatorio-de-trocas',
                'Trocas',
                icons.repeat,
                true
              )}
          </>
        )}
        {userHasPermission('report/r') &&
          renderNavLink('/relatorios', 'Relatórios', icons.timeline, true)}
        {renderNavLink('/cadastros', 'Cadastros', icons.assignment, true)}
      </div>

      <div>
        {userLogged?.group?.id === 1 &&
          renderNavLink('/settings', 'Configurações', icons.settings, true)}
        <ListItem
          className={clsx(
            'h-12',
            classes.logoutItem,
            !config.open && classes.listItemCollapsed
          )}
          button
          onClick={logoutFunction}
        >
          <Tooltip title="Sair" placement="right">
            <ListItemIcon id="btnSair">
              <img
                src={icons.exitToApp}
                alt=""
                className={classes.logoutIconImg}
                style={{ maxWidth: 24, maxHeight: 24 }}
              />
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            primary="Sair"
            className={clsx(!config.open && classes.listItemTextHidden)}
          />
        </ListItem>

        <Divider />

        {config.open && (
          <div className="text-center mt-2 flex flex-col items-center px-1">
            <Typography className={classes.dataText}>
              Última sincronização: {data}
            </Typography>
            <img alt="Logo" src={logo} className="w-44 my-5" />
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuSidebar;
